var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6571 3.53987C26.5336 0.293676 21.4596 0.293676 18.3228 3.53987L16.9998 4.91745L15.6768 3.53987C12.5534 0.293676 7.47929 0.293676 4.34258 3.53987C1.21914 6.78606 1.21914 12.0371 4.34258 15.2836L16.9727 28.3913L17 28.3641L17.0273 28.3913L29.6574 15.2836C32.7809 12.0374 32.7809 6.78643 29.6574 3.53987H29.6571Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5476 5.6341C24.9447 2.92893 20.7163 2.92893 18.1024 5.6341L16.9998 6.78208L15.8973 5.6341C13.2945 2.92893 9.06608 2.92893 6.45215 5.6341C3.84928 8.33926 3.84928 12.7151 6.45215 15.4206L16.9773 26.3437L17 26.3209L17.0227 26.3437L27.5479 15.4206C30.1507 12.7154 30.1507 8.33956 27.5479 5.6341H27.5476Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.438 7.72832C23.3557 5.56419 19.973 5.56419 17.8819 7.72832L16.9999 8.64671L16.1179 7.72832C14.0356 5.56419 10.6529 5.56419 8.56172 7.72832C6.47943 9.89245 6.47943 13.3931 8.56172 15.5575L16.9818 24.296L17 24.2778L17.0182 24.296L25.4383 15.5575C27.5206 13.3934 27.5203 9.89269 25.438 7.72832Z",
    fill: "#3F5497",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3285 9.82255C21.7668 8.19945 19.2298 8.19945 17.6614 9.82255L16.9999 10.5113L16.3384 9.82255C14.7767 8.19945 12.2396 8.19945 10.6713 9.82255C9.10957 11.4456 9.10957 14.0711 10.6713 15.6944L16.9864 22.2483L17 22.2346L17.0136 22.2483L23.3287 15.6944C24.8904 14.0713 24.8902 11.4458 23.3285 9.82255Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4179 11.5923C20.3119 10.4429 18.5153 10.4429 17.4046 11.5923L16.9362 12.0801L16.4677 11.5923C15.3618 10.4429 13.5651 10.4429 12.4545 11.5923C11.3485 12.7417 11.3485 14.601 12.4545 15.7506L16.9266 20.3918L16.9363 20.3821L16.9459 20.3918L21.418 15.7506C22.524 14.6011 22.5239 12.7418 21.4179 11.5923Z",
    fill: "#9B7BD0",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9393 13.0582C19.1977 12.2875 17.9931 12.2875 17.2484 13.0582L16.9343 13.3853L16.6201 13.0582C15.8786 12.2875 14.6739 12.2875 13.9292 13.0582C13.1877 13.829 13.1877 15.0756 13.9292 15.8464L16.9278 18.9584L16.9343 18.9519L16.9408 18.9584L19.9394 15.8464C20.6809 15.0757 20.6808 13.829 19.9393 13.0582Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4646 14.5242C18.0874 14.1322 17.4747 14.1322 17.096 14.5242L16.9362 14.6906L16.7765 14.5242C16.3993 14.1322 15.7866 14.1322 15.4079 14.5242C15.0307 14.9162 15.0307 15.5502 15.4079 15.9423L16.933 17.525L16.9362 17.5217L16.9395 17.525L18.4646 15.9423C18.8418 15.5503 18.8417 14.9162 18.4646 14.5242Z",
    fill: "#5A8C8D",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart1);
export default __webpack_public_path__ + "static/media/Heart-1.19c1407ecabd41dd9027f2396f0cb42d.svg";
export { ForwardRef as ReactComponent };